<modal-form-container
  [showModal]="add_recipient"
  title="Message recipients"
  className="rl-modal md:w-[90vw] lg:w-[960px] xl:w-[1040px]"
  (closeModalEvent)="close.emit()"
>
  <div class="rl">
    <p class="rl__total">
      <strong>{{ formatCount(totalRecipients) }}</strong>
      {{ totalRecipients === 1 ? "recipient" : "recipients" }} in total
    </p>
    <p class="rl__hint">
      The total counts everyone reached through tags, organizations, segments and
      typed-in numbers. Only what was picked when composing is listed below.
    </p>

    <app-routing-tab class="rl__tabs" [tabList]="tabs" />

    <app-search-input label="Search recipients"
      class="rl__search"
      [placeholder]="searchPlaceholder"
      (valueChange)="updateSearchTerm($event)"
    />

    <div class="rl__panel">
      @if (loading) {
        <div class="rl__skel" role="status" aria-label="Loading recipients">
          @for (n of [0, 1, 2, 3, 4]; track n) {
            <span class="bk-skel" style="width: 100%; height: 16px"></span>
          }
        </div>
      } @else if (fetchError) {
        <p class="rl__error" role="alert">
          <span class="bk-sym" aria-hidden="true">error</span>
          {{ fetchError }}
        </p>
      } @else if (rows.length === 0) {
        <app-empty-state
          icon="contacts"
          [message]="emptyMessage"
          [query]="searchTerm"
          size="small"
        />
      } @else {
        <div class="rl__scroll">
          <table class="bk-log">
            <thead>
              <tr>
                @if (isContacts) {
                  <th scope="col">Name</th>
                  <th scope="col">Phone number</th>
                  <th scope="col" class="col-gender">Gender</th>
                  <th scope="col" class="col-country">Country</th>
                } @else {
                  <th scope="col">Name</th>
                  <th scope="col" class="col-desc">Description</th>
                }
              </tr>
            </thead>
            <tbody>
              @if (isContacts) {
                @for (row of rows; track $index) {
                  <tr>
                    <td class="rl__name">{{ row?.fullName || "—" }}</td>
                    <td class="quiet">{{ row?.mobileNumber || "—" }}</td>
                    <td class="quiet col-gender rl__cap">{{ (row?.gender || "—").toLowerCase() }}</td>
                    <td class="quiet col-country">{{ row?.country || "—" }}</td>
                  </tr>
                }
              } @else {
                @for (row of rows; track $index) {
                  <tr>
                    <td class="rl__name">{{ row?.name || "—" }}</td>
                    <td class="quiet col-desc">
                      <span class="rl__desc">{{ row?.description || "—" }}</span>
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
        </div>
      }
    </div>
  </div>
</modal-form-container>
